<template>
    <CHeader fixed with-subheader 
        style="background-color:#cc9933;">
        <CHeaderNav class="mr-auto">
            <CHeaderNavItem class="px-3">
                <button
                    type="button"
                    class="hamburger-button"
                    aria-label="Abrir menu"
                    @click="openMenu"
                >
                    <span></span>
                    <span></span>
                    <span></span>
                </button>
            </CHeaderNavItem>
        </CHeaderNav>
        <CHeaderNav class="mr-2">
            <TheHeaderDropdownAccnt/>
        </CHeaderNav>
        <CSubheader class="px-3">
            <CBreadcrumbRouter class="border-0 mb-0"/>
        </CSubheader>
        <transition name="hamburger-overlay-fade">
            <div
                v-if="showMenu"
                class="hamburger-overlay"
                @click="closeMenu"
            ></div>
        </transition>
        <transition name="hamburger-drawer-slide">
            <aside
                v-if="showMenu"
                class="hamburger-drawer"
                @click.stop
            >
                <div class="hamburger-drawer-header">
                    <button
                        type="button"
                        class="hamburger-close"
                        aria-label="Cerrar menu"
                        @click="closeMenu"
                    >
                        &times;
                    </button>
                </div>
                <nav class="hamburger-menu">
                <router-link class="hamburger-link" to="/charges" @click.native="closeMenu">
                    {{$t('charges.title').toUpperCase()}}
                </router-link>
                <router-link class="hamburger-link" to="/empresas" @click.native="closeMenu">
                    {{$t('empresas.title').toUpperCase()}}
                </router-link>
                <router-link class="hamburger-link" to="/vehicles" @click.native="closeMenu">
                    {{$t('vehicles.title').toUpperCase()}}
                </router-link>
                <button type="button" class="hamburger-link hamburger-link-button" @click="onShowWhatsAppFromMenu">
                    {{$t('grupo_wp.title').toUpperCase()}}
                </button>
                <router-link class="hamburger-link" to="/directories" @click.native="closeMenu">
                    {{$t('directories.title').toUpperCase()}}
                </router-link>
                <router-link class="hamburger-link" to="/providers" @click.native="closeMenu">
                    {{$t('providers.title').toUpperCase()}}
                </router-link>
                <router-link class="hamburger-link" to="/carrier-gallery" @click.native="closeMenu">
                    {{$t('carrierGallery.title').toUpperCase()}}
                </router-link>
                <router-link class="hamburger-link" to="/terms" @click.native="closeMenu">
                    {{$t('terms.title').toUpperCase()}}
                </router-link>
                <router-link v-if="!isAuth" class="hamburger-link" to="/login" @click.native="closeMenu">
                    {{$t('login.label').toUpperCase()}}
                </router-link>
                <router-link v-if="!isAuth" class="hamburger-link" to="/register" @click.native="closeMenu">
                    {{$t('login.register').toUpperCase()}}
                </router-link>
                </nav>
            </aside>
        </transition>
        <CModal
            color="warning"
            :show.sync="showDetail"
            :title="$t('charges.detail')"
        >
            <div v-if='!isAuth'>
                {{messageLogin}}
            </div>
            <div v-else>
                <CRow>
                    <div class="col-sm-12">
                        {{messagePremium}}
                    </div>
                </CRow>
                <CRow>
                    <div class="col-sm-6 offset-sm-3 mt-5">
                        <a :href="urlWhatsappPremium" class="btn-whatsapp" target="_blank">
                            <CIcon :content="iconChat" size="3xl"/> {{ $t('button.whatsapp') }} 
                        </a>
                    </div>
                </CRow>
            </div>
        </CModal>
    </CHeader>
</template>

<script>
import store from '../store'
import { cilChatBubble } from '@coreui/icons';
import TheHeaderDropdownAccnt from './TheHeaderDropdownAccnt'

export default {
    name: 'TheHeader',
    components: {
        TheHeaderDropdownAccnt,
    },
    data() {
        return {
            showMenu: false,
            showDetail: false,
            originalBodyOverflow: '',
            iconChat: cilChatBubble,
        }
    },
    computed: {
        isAuth() {
            return localStorage.getItem('login') === 'true';
        },
        urlWhatsappPremium() {
            if (store.state.configuration != null 
                && store.state.configuration.configuration != null) {
                return "https://wa.me/"+store.state.configuration.configuration.text_not_show_premium_trip_phone;
            } else {
                return "";
            }
        },
        messageLogin() {
            //return "Debes Registrarte primero, te lleva 1 minuto";
            if (store.state.configuration != null 
                && store.state.configuration.configuration != null) {
                return store.state.configuration.configuration.registrate;
            } else {
                return "";
            }
        },
        messagePremium() {
            //return "Debes Registrarte primero, te lleva 1 minuto";
            if (store.state.configuration != null) {
                return store.state.configuration.configuration.text_not_show_premium_trip;
            } else {
                return "aoeu";
            }
        },
    },
    methods: {
        openMenu() {
            if (this.showMenu) {
                return;
            }

            this.originalBodyOverflow = document.body.style.overflow;
            this.showMenu = true;
            document.body.style.overflow = 'hidden';
        },
        closeMenu() {
            this.showMenu = false;
            document.body.style.overflow = this.originalBodyOverflow;
        },
        onShowDetail() {
            console.log("aoeuaoeu");
            this.showDetail = true;
        },
        onShowWhatsAppFromMenu() {
            this.closeMenu();
            this.onShowDetail();
        }
    },
    beforeDestroy() {
        document.body.style.overflow = this.originalBodyOverflow;
    }
}
</script>

<style>
.c-header .c-header-nav .c-header-nav-link, .c-header .c-header-nav .c-header-nav-btn {
    font-weight: bold;
    color: white !important; 
}

.c-header .c-subheader {
    font-weight: bold;
    color: white !important; 
    background-color: #cc9933;
}

.breadcrumb-item .active {
    font-weight: bold;
    color: white !important; 
}    

.active {
    font-size: 20px !important;
    color: white !important;
    font-weight: bold !important;
}

.hamburger-button {
    width: 44px;
    height: 44px;
    border: 1px solid rgba(255, 255, 255, 0.7);
    border-radius: 4px;
    background: transparent;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 5px;
    padding: 0;
}

.hamburger-button span {
    width: 24px;
    height: 3px;
    background: white;
    border-radius: 2px;
    display: block;
}

.hamburger-menu {
    display: flex;
    flex-direction: column;
}

.hamburger-overlay {
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 1039;
    position: fixed;
    background: rgba(0, 0, 0, 0.35);
}

.hamburger-drawer {
    top: 0;
    left: 0;
    width: min(320px, 82vw);
    height: 100vh;
    z-index: 1040;
    position: fixed;
    overflow-y: auto;
    background: #ffffff;
    box-shadow: 4px 0 22px rgba(0, 0, 0, 0.22);
}

.hamburger-drawer-header {
    height: 56px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 0 14px;
    border-bottom: 1px solid #e5e5e5;
}

.hamburger-close {
    width: 36px;
    height: 36px;
    border: 0;
    color: #1c2b4a;
    cursor: pointer;
    font-size: 30px;
    line-height: 1;
    background: transparent;
}

.hamburger-link {
    color: #1c2b4a;
    font-weight: bold;
    padding: 14px 18px;
    border-bottom: 1px solid #e5e5e5;
    text-decoration: none;
}

.hamburger-drawer .hamburger-link.active {
    color: #1c2b4a !important;
    font-size: inherit !important;
}

.hamburger-link:hover {
    color: #cc9933;
    text-decoration: none;
}

.hamburger-link-button {
    background: transparent;
    border-left: 0;
    border-right: 0;
    border-top: 0;
    text-align: left;
    width: 100%;
}

.hamburger-overlay-fade-enter-active,
.hamburger-overlay-fade-leave-active {
    transition: opacity 0.25s ease;
}

.hamburger-overlay-fade-enter,
.hamburger-overlay-fade-leave-to {
    opacity: 0;
}

.hamburger-drawer-slide-enter-active,
.hamburger-drawer-slide-leave-active {
    transition: transform 0.32s ease;
}

.hamburger-drawer-slide-enter,
.hamburger-drawer-slide-leave-to {
    transform: translateX(-100%);
}

</style>
